"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTooltipVisibleSelector = void 0;
var specs_1 = require("../../../../specs");
var constants_1 = require("../../../../specs/constants");
var create_selector_1 = require("../../../../state/create_selector");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var tooltip_1 = require("./tooltip");
exports.isTooltipVisibleSelector = (0, create_selector_1.createCustomCachedSelector)([get_settings_specs_1.getSettingsSpecSelector, tooltip_1.getTooltipInfoSelector], function (settingsSpec, tooltipInfo) {
    if ((0, specs_1.getTooltipType)(settingsSpec) === constants_1.TooltipType.None) {
        return false;
    }
    return tooltipInfo.values.length > 0;
});
//# sourceMappingURL=is_tooltip_visible.js.map